import React from 'react'
import { Pause, PlayArrow } from '@material-ui/icons'
import style from './StatusButton.module.scss'


function StatusButton(props:any) {
   
    return (
        <div onClick={props.click} >
        <div className={props.storeState === "PAUSED" ? style.container_close : style.container_open } >
            {props.storeState === "PAUSED" ? ( <PlayArrow className={style.play}/>) : (<Pause className={style.pause} />)}
            
        </div>
         {/* <button className={props.storeState ==="PAUSED" ? style.btn__close : style.btn__open } >{props.title}</button> */}
         <span>{props.title}</span>
        </div>
    )
}

export default StatusButton
